import React from 'react';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';

import randomstring from 'uuid/v4';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

class Filter extends React.Component {
    state = {
        estado: this.props.filtro,
    };

    handleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };

    handleClose = (estado) => (event) => {
        this.props.handleClose(estado);
    };

    render() {
        const { estado } = this.state;
        const { intl } = this.props;
        return (
            <Dialog
                open={true}
                onClose={this.handleClose(null, null, null)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent className={'padding_borders'}>
                    <div className="flex_full_row margin_top_18 align_center">
                        <FormControl className={'flex_full width100 barlow_italic c_slate'}>
                            <InputLabel htmlFor="age-native-simple">
                                {intl.formatMessage({ id: 'local_table_configurance' })}
                            </InputLabel>
                            <Select
                                native
                                value={estado}
                                onChange={this.handleChange}
                                inputProps={{ name: 'estado', id: 'estado-id' }}
                            >
                                <option key={randomstring()} value={undefined} />
                                <option key={randomstring()} value={0}>
                                    {intl.formatMessage({ id: 'local_table_configurance_no' })}
                                </option>
                                <option key={randomstring()} value={1}>
                                    {intl.formatMessage({ id: 'local_table_configurance_partial' })}
                                </option>
                                <option key={randomstring()} value={3}>
                                    {intl.formatMessage({ id: 'local_table_configurance_yes' })}
                                </option>
                            </Select>
                        </FormControl>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleClose(null)} color="primary">
                        <FormattedMessage id="cancel" />
                    </Button>
                    <Button onClick={this.handleClose(estado)} color="primary" autoFocus>
                        <FormattedMessage id="accept" />
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

Filter.propTypes = {
    intl: intlShape.isRequired,
};

export default injectIntl(Filter);



// WEBPACK FOOTER //
// ./src/components/complex/inventory/locals/FilterMenu.js